var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { c as _c } from "react/compiler-runtime";
import { ESTABLISHMENT_CITY, ESTABLISHMENT_NAME } from '@/constants/config';
import { BBookableTypeEnum } from '@/types/backend';
import EntityCardMainContentTemplate from '../components/EntityCardMainContentTemplate';
import ExperienceCardDetailContent from './ExperienceCardDetailContent';
const locationText = `${ESTABLISHMENT_NAME}, ${ESTABLISHMENT_CITY}`;
const ExperienceCardContent = t0 => {
    var _a, _b;
    const $ = _c(15);
    let experience;
    let incomingLanguages;
    let props;
    if ($[0] !== t0) {
        ({ experience,
            languages: incomingLanguages } = t0, props = __rest(t0, ["experience", "languages"]));
        $[0] = t0;
        $[1] = experience;
        $[2] = incomingLanguages;
        $[3] = props;
    }
    else {
        experience = $[1];
        incomingLanguages = $[2];
        props = $[3];
    }
    const image = ((_b = (_a = experience.medias) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.length) ? experience.medias.media[0] : null;
    const languages = incomingLanguages || experience.type === BBookableTypeEnum.Activity && experience.informations.spokenLangs && experience.informations.spokenLangs.length > 0 && experience.informations.spokenLangs || undefined;
    let t1;
    if ($[4] !== experience || $[5] !== props) {
        t1 = <ExperienceCardDetailContent experience={experience} {...props}/>;
        $[4] = experience;
        $[5] = props;
        $[6] = t1;
    }
    else {
        t1 = $[6];
    }
    let t2;
    if ($[7] !== experience.informations || $[8] !== experience.name || $[9] !== experience.typeActivity.name || $[10] !== image || $[11] !== languages || $[12] !== props || $[13] !== t1) {
        t2 = <EntityCardMainContentTemplate image={image} information={experience.informations} languages={languages} location={locationText} title={experience.name} typeContent={experience.typeActivity.name} {...props}>{t1}</EntityCardMainContentTemplate>;
        $[7] = experience.informations;
        $[8] = experience.name;
        $[9] = experience.typeActivity.name;
        $[10] = image;
        $[11] = languages;
        $[12] = props;
        $[13] = t1;
        $[14] = t2;
    }
    else {
        t2 = $[14];
    }
    return t2;
};
export default ExperienceCardContent;
